module.exports = __webpack_public_path__ + "img/3x.d97b06f.jpg";